// extracted by mini-css-extract-plugin
module.exports = {"muteSwitchContainer":"ec0Tg","iconContainer":"_24YfB","iconLabel":"_3Gd9v"};